/**
 * Categorias náuticas do NautMax (substituem as categorias automotivas do Traccar).
 * `value` é o slug salvo em device.category; `label` é o rótulo exibido.
 * O ícone de cada categoria é resolvido em `vesselIcons.tsx`.
 */
export interface VesselCategory {
  value: string;
  label: string;
}

export const VESSEL_CATEGORIES: VesselCategory[] = [
  { value: 'barco', label: 'Barco' },
  { value: 'casco', label: 'Casco' },
  { value: 'bassboat', label: 'BassBoat' },
  { value: 'bote', label: 'Bote' },
  { value: 'apoio', label: 'Apoio' },
  { value: 'canoa', label: 'Canoa' },
  { value: 'caiaque', label: 'Caiaque' },
  { value: 'lancha', label: 'Lancha' },
  { value: 'reboque', label: 'Reboque' },
  { value: 'veleiro', label: 'Veleiro' },
  { value: 'catamara', label: 'Catamarã' },
  { value: 'iate', label: 'Iate' },
  { value: 'escuna', label: 'Escuna' },
  { value: 'ferryboat', label: 'Ferry boat' },
  { value: 'balsa', label: 'Balsa' },
  { value: 'resgate', label: 'Resgate' },
  { value: 'plataforma', label: 'Plataformas' },
  { value: 'flutuante', label: 'Flutuante' },
  { value: 'jetski', label: 'Jet ski' },
];

export const VESSEL_CATEGORY_LABEL: Record<string, string> = Object.fromEntries(
  VESSEL_CATEGORIES.map((c) => [c.value, c.label]),
);

/** Paleta de cores selecionável para o ícone da embarcação (white-label friendly). */
export interface IconColor {
  value: string;
  label: string;
}

export const ICON_COLORS: IconColor[] = [
  { value: '#0B3A5B', label: 'Marinho' },
  { value: '#007AFF', label: 'Azul' },
  { value: '#E02128', label: 'Vermelho' },
  { value: '#1FA463', label: 'Verde' },
  { value: '#F59E0B', label: 'Âmbar' },
  { value: '#7C3AED', label: 'Roxo' },
  { value: '#0E7490', label: 'Petróleo' },
  { value: '#475569', label: 'Grafite' },
];

export const DEFAULT_ICON_COLOR = ICON_COLORS[0].value;

/** Cor escolhida do ícone, salva em device.attributes.iconColor. */
export function getDeviceIconColor(attributes: Record<string, unknown> | null | undefined): string | null {
  const c = attributes?.iconColor;
  return typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c) ? c : null;
}
